import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        { path: '/', redirect: { name: 'dashboard' } },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/components/login/Login')
        },
        {
            path: '/error/not-found',
            name: '404',
            component: () => import('@/components/errors/404')
        },
        {
            path: '/upgrading',
            name: 'upgrading',
            component: () => import('@/components/errors/upgrading')
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('@/components/login/Register')
        },
        {
            path: '/forgotpw',
            name: 'forgotpw',
            component: () => import('@/components/login/ForgotPassword')
        },
        {
            path: '/resetpw',
            name: 'resetpw',
            component: () => import('@/components/login/ResetPassword')
        },
        {
            path: '/user-activation',
            name: 'user-activation',
            component: () => import('@/components/login/UserActivation')
        },
        {
            path: '/vm/console/:VMID',
            name: 'vmConsole',
            component: () => import('@/components/Console')
        },
        {
            path: '/home',
            name: 'Home',
            meta: { path: '/home', breadcrumb: 'Home' },
            component: () => import('@/components/Home'),
            redirect: '/home/dashboard',
            children: [
                {
                    path: 'cloud-vps',
                    meta: {
                        path: '/home/cloud-vps',
                        title: '<span class="fa fa-cloud"></span> <span id="breadcrumb">Your vps list</span>',
                        breadcrumb: 'Cloud VPS',
                        category: 'List',
                        name: 'VPS List',
                        i18n: 'vps.breadcrumb'
                    },
                    component: () => import('@/components/services/cloudvps/VPSList')
                },
                {
                    path: 'cloud-vps/snapshot',
                    meta: {
                        path: '/home/cloud-vps',
                        title: '<span class="fas fa-camera"></span> <span id="breadcrumb">Your snapshot list</span>',
                        breadcrumb: 'Cloud VPS',
                        category: 'Snapshot',
                        name: 'VPS Snapshot',
                        i18n: 'snapshot.breadcrumb'
                    },
                    component: () => import('@/components/services/cloudvps/SnapshotVPS')
                },
                {
                    path: 'cloud-vps/backup',
                    meta: {
                        path: '/home/cloud-vps',
                        title: '<span class="fas fa-hdd"></span> <span id="breadcrumb">Your backup list</span>',
                        breadcrumb: 'Cloud VPS',
                        category: 'Backup',
                        name: 'VPS Backup',
                        i18n: 'backup.breadcrumb'
                    },
                    component: () => import('@/components/services/cloudvps/BackupVPS')
                },
                {
                    path: 'cloud-vps/detail/:VMID',
                    meta: {
                        path: '/home/cloud-vps',
                        title: '<span class="fas fa-desktop"></span> <span id="breadcrumb">Your VPS detail</span>',
                        breadcrumb: 'Cloud VPS',
                        category: 'VPS Detail',
                        name: 'VPS Detail',
                        i18n: 'detail.breadcrumb'
                    },
                    component: () => import('@/components/services/cloudvps/VPSDetail')
                },
                {
                    path: 'dedicated-server',
                    meta: {
                        path: '/home/dedicated-server',
                        title: '<span class="fas fa-server"></span> <span id="breadcrumb">Your dedicated server list</span>',
                        breadcrumb: 'Dedicated Server',
                        category: 'List',
                        name: 'Dedicated Server List',
                        i18n: 'dedicated.breadcrumb'
                    },
                    component: () => import('@/components/services/dedicated/DedicatedList')
                },
                {
                    path: 'dedicated-server/detail/:VMID',
                    meta: {
                        path: '/home/dedicated-server',
                        title: '<span class="fas fa-desktop"></span> <span id="breadcrumb">Your dedicated server detail</span>',
                        breadcrumb: 'Dedicated Server',
                        category: 'Dedicated Server Detail',
                        name: 'Dedicated Server Detail',
                        i18n: 'dedicatedDetail.breadcrumb'
                    },
                    component: () => import('@/components/services/dedicated/DedicatedDetail')
                },
                {
                    path: 'hosting',
                    meta: {
                        path: '/home/hosting',
                        title: '<span class="fas fa-rocket"></span> <span id="breadcrumb">Your hosting list</span>',
                        breadcrumb: 'Hosting',
                        category: 'List',
                        name: 'Hosting List',
                        i18n: 'hosting.breadcrumb'
                    },
                    component: () => import('@/components/services/hosting/List.vue')
                },
                {
                    path: 'order',
                    meta: {
                        path: '/home/order',
                        title: '<span class="fas fa-cart-plus"></span> <span id="breadcrumb">New Order</span>',
                        breadcrumb: 'Order',
                        name: 'New Order',
                        i18n: 'orderNew.breadcrumb'
                    },
                    component: () => import('@/components/orders/NewOrder')
                },
                {
                    path: 'order/history',
                    meta: {
                        path: '/home/order',
                        title: '<span class="fas fa-file-invoice-dollar"></span> <span id="breadcrumb">Order History</span>',
                        breadcrumb: 'Order',
                        category: 'History',
                        name: 'Order History',
                        i18n: 'order.breadcrumb'
                    },
                    component: () => import('@/components/orders/History')
                },
                {
                    path: 'order/topup',
                    meta: {
                        path: '/home/order',
                        title: '<span class="fas fa-wallet"></span> <span id="breadcrumb">Topup your account</span>',
                        breadcrumb: 'Order',
                        category: 'Topup',
                        name: 'Topup',
                        i18n: 'topup.breadcrumb'
                    },
                    component: () => import('@/components/orders/Topup')
                },
                {
                    path: 'order/detail/:orderID',
                    meta: {
                        path: '/home/order',
                        title: '<span class="fas fa-file-invoice"></span> <span id="breadcrumb">Your order detail</span>',
                        breadcrumb: 'Order',
                        category: 'Order Detail',
                        name: 'Order Detail',
                        i18n: 'orderDetail.breadcrumb'
                    },
                    component: () => import('@/components/orders/OrderDetail')
                },
                {
                    path: 'password',
                    name: 'password',
                    meta: {
                        title: '<span class="fa fa-key"></span> <span id="breadcrumb">Change Password</span>',
                        breadcrumb: 'Password',
                        path: '/home/password',
                        i18n: 'profile.pw_breadcrumb'
                    },
                    component: () => import('@/components/login/Password')
                },
                {
                    path: 'profile',
                    name: 'profile',
                    meta: {
                        title: '<span class="fas fa-id-card"></span> <span id="breadcrumb">Profile Detail</span>',
                        breadcrumb: 'Profile',
                        path: '/home/profile',
                        i18n: 'profile.breadcrumb'
                    },
                    component: () => import('@/components/login/Profile')
                },
                {
                    path: 'notification',
                    name: 'notification',
                    meta: {
                        title: '<span class="fa fa-bell-o"></span> <span id="breadcrumb">Notification</span>',
                        breadcrumb: 'Notification',
                        path: '/home/notification',
                        i18n: 'notification.breadcrumb'
                    },
                    component: () => import('@/components/Notification')
                },
                {
                    path: 'log',
                    name: 'log',
                    meta: {
                        title: '<span class="fa fa-table"></span> <span id="breadcrumb">Activity Log</span>',
                        breadcrumb: 'Log',
                        path: '/home/log',
                        i18n: 'log.breadcrumb'
                    },
                    component: () => import('@/components/LogList')
                },
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    meta: {
                        title: '<span class="fa fa-bar-chart-o"></span> <span id="breadcrumb">Dashboard</span>',
                        breadcrumb: 'Dashboard',
                        path: '/home/dashboard',
                        i18n: 'dashboard.breadcrumb'
                    },
                    component: () => import('@/components/Dashboard')
                },
                {
                    path: 'security/2fa',
                    name: 'two_fa',
                    meta: {
                        title: '<i class="fas fa-shield-alt"></i> <span id="breadcrumb">Security</span>',
                        breadcrumb: 'Security',
                        path: '/home/dashboard',
                        i18n: 'two_fa.breadcrumb'
                    },
                    component: () => import('@/components/security/TwoFactorAuthentication')
                },
                {
                    path: 'team-manager',
                    name: 'team-manager',
                    meta: {
                        title: '<i class="fas fa-users"></i> <span id="breadcrumb">Team Manager</span>',
                        breadcrumb: 'Team Manager',
                        path: '/home/dashboard',
                        i18n: 'team.breadcrumb'
                    },
                    component: () => import('@/components/teams/TeamManager')
                },
                {
                    path: 'team/join',
                    name: 'team-join',
                    meta: {
                        title: '<i class="fas fa-users"></i> <span id="breadcrumb">Team Manager</span>',
                        breadcrumb: 'Team Manager',
                        path: '/home/dashboard',
                        i18n: 'team.breadcrumb'
                    },
                    component: () => import('@/components/teams/JoinTeam')
                },
                {
                    name: 'proxy-list',
                    path: 'proxy',
                    meta: {
                        title: '<i class="fas fa-network-wired"></i> <span id="breadcrumb">Proxy List</span>',
                        breadcrumb: 'Proxy',
                        path: '/home/dashboard',
                        i18n: 'proxy.breadcrumb'
                    },
                    component: () => import('@/components/services/proxy/List')
                },
                {
                    name: 'rsd-proxy-cdkey',
                    path: 'rsd-proxy/cdkey',
                    meta: {
                        title: '<i class="fas fa-key"></i> <span id="breadcrumb">RSD Proxy CD Key</span>',
                        breadcrumb: 'RSD Proxy CD Key',
                        path: '/home/dashboard',
                        i18n: 'rsdproxy.breadcrumb'
                    },
                    component: () => import('@/components/services/proxy/RsdProxyCDKey.vue')
                },
                {
                    name: 'ticket',
                    path: 'ticket',
                    meta: {
                        title: '<i class="fas fa-ticket-alt"></i> <span id="breadcrumb">Ticket List</span>',
                        breadcrumb: 'Tickets',
                        path: '/home/dashboard',
                        i18n: 'ticket.breadcrumb'
                    },
                    component: () => import('@/components/tickets/Ticket')
                },
                {
                    name: 'ticket-detail',
                    path: 'ticket/detail/:ticketID',
                    meta: {
                        title: '<i class="fas fa-ticket-alt"></i> <span id="breadcrumb">Ticket List</span>',
                        breadcrumb: 'Tickets',
                        path: '/home/ticket',
                        i18n: 'ticket.breadcrumb',
                        category: 'Ticket Detail',
                        name: 'Tickets'
                    },
                    component: () => import('@/components/tickets/TicketDetail')
                },
                {
                    name: 'referral',
                    path: 'referral',
                    meta: {
                        title: '<i class="fas fa-share-alt-square"></i> <span id="breadcrumb">Referral</span>',
                        breadcrumb: 'Referral',
                        path: '/home/dashboard',
                        i18n: 'referrals.breadcrumb',
                        name: 'Referral'
                    },
                    component: () => import('@/components/Referral')
                }
            ]
        },
        { path: '*', redirect: { name: '404' } }
    ]
})
